<script lang="ts">
  import { onMount } from 'svelte'
  import { api } from '../lib/api'
  import { notify } from '../lib/toast'
  import ApiTokens from './ApiTokens.svelte'

  let settings = $state<Record<string, string>>({})

  const fields: Array<[string, string]> = [
    ['profile_name', 'Имя Happ profile'],
    ['address_list', 'MikroTik address_list'],
    ['routing_table', 'MikroTik routing table'],
    ['mikrotik_forward_to', 'MikroTik DNS forward-to (IP резолвера обхода)'],
    ['remote_dns', 'Remote DNS (DoH URL)'],
    ['domestic_dns', 'Domestic DNS (DoH URL)'],
    ['geoip_url', 'Geoip URL'],
    ['geosite_url', 'Geosite URL']
  ]

  onMount(async () => { settings = await api.getSettings() })

  async function save(key: string) {
    try {
      await api.updateSetting(key, settings[key] || '')
      notify('Сохранено', 'ok')
    } catch (e: any) { notify(e.message, 'err') }
  }

  function parse(k: string) {
    try { return JSON.parse(settings[k] || '{}') } catch { return {} }
  }

  let direct = $derived(parse('happ_direct'))
  let block = $derived(parse('happ_block'))

  let newDirectGs = $state(''), newDirectGi = $state(''), newBlockGs = $state('')

  async function addToJson(key: string, field: string, value: string) {
    const v = value.trim().replace(/^(geosite|geoip):/, '')
    if (!v) return
    const current = parse(key)
    if (!current[field]) current[field] = []
    if (current[field].includes(v)) return
    current[field].push(v)
    settings[key] = JSON.stringify(current)
    await save(key)
  }

  async function removeFromJson(key: string, field: string, value: string) {
    const current = parse(key)
    current[field] = (current[field] || []).filter((x: string) => x !== value)
    settings[key] = JSON.stringify(current)
    await save(key)
  }
</script>

<div class="card mb-4">
  <h2 class="text-base font-semibold mb-4">Глобальные настройки</h2>
  <div class="space-y-3">
    {#each fields as [k, label]}
      <div>
        <label class="label">{label}</label>
        <div class="flex gap-2">
          <input class="input flex-1" bind:value={settings[k]}>
          <button class="btn btn-secondary" onclick={() => save(k)}>Save</button>
        </div>
      </div>
    {/each}
  </div>
</div>

<div class="card">
  <h2 class="text-base font-semibold mb-1">Happ Direct / Block</h2>
  <p class="text-xs text-muted mb-4">Применяется ко всем Happ targets</p>

  <div class="space-y-5">
    <div>
      <div class="label">Direct sites (geosite) — идут мимо VPN</div>
      <div class="flex flex-wrap gap-1 mb-2">
        {#each (direct.geosite || []) as t}
          <span class="chip chip-blue">geosite:{t}<button class="chip-remove" onclick={() => removeFromJson('happ_direct', 'geosite', t)}>×</button></span>
        {/each}
      </div>
      <div class="flex gap-2">
        <input class="input input-sm flex-1" placeholder="private, category-ru..." bind:value={newDirectGs}
               onkeydown={(e) => { if (e.key === 'Enter') { addToJson('happ_direct', 'geosite', newDirectGs); newDirectGs = '' } }}>
        <button class="btn btn-secondary" onclick={() => { addToJson('happ_direct', 'geosite', newDirectGs); newDirectGs = '' }}>+</button>
      </div>
    </div>

    <div>
      <div class="label">Direct IP (geoip)</div>
      <div class="flex flex-wrap gap-1 mb-2">
        {#each (direct.geoip || []) as t}
          <span class="chip chip-purple">geoip:{t}<button class="chip-remove" onclick={() => removeFromJson('happ_direct', 'geoip', t)}>×</button></span>
        {/each}
      </div>
      <div class="flex gap-2">
        <input class="input input-sm flex-1" placeholder="private, ru..." bind:value={newDirectGi}
               onkeydown={(e) => { if (e.key === 'Enter') { addToJson('happ_direct', 'geoip', newDirectGi); newDirectGi = '' } }}>
        <button class="btn btn-secondary" onclick={() => { addToJson('happ_direct', 'geoip', newDirectGi); newDirectGi = '' }}>+</button>
      </div>
    </div>

    <div>
      <div class="label">Block sites (geosite)</div>
      <div class="flex flex-wrap gap-1 mb-2">
        {#each (block.geosite || []) as t}
          <span class="chip" style="background:rgba(239,68,68,0.1);border-color:rgba(239,68,68,0.3);color:#fca5a5">
            geosite:{t}<button class="chip-remove" onclick={() => removeFromJson('happ_block', 'geosite', t)}>×</button>
          </span>
        {/each}
      </div>
      <div class="flex gap-2">
        <input class="input input-sm flex-1" placeholder="category-ads..." bind:value={newBlockGs}
               onkeydown={(e) => { if (e.key === 'Enter') { addToJson('happ_block', 'geosite', newBlockGs); newBlockGs = '' } }}>
        <button class="btn btn-secondary" onclick={() => { addToJson('happ_block', 'geosite', newBlockGs); newBlockGs = '' }}>+</button>
      </div>
    </div>
  </div>
</div>

<div class="mt-4">
  <ApiTokens />
</div>
